import { Component, inject, PLATFORM_ID } from '@angular/core';

import { MainNavComponent } from '../shared/components/main-nav/main-nav.component';
import { HeroComponent } from './hero/hero.component';
import { KeyFeaturesComponent } from './key-features/key-features.component';
import { CustomersComponent } from './customers/customers.component';
import { BenefitsComponent } from './benefits/benefits.component';
import { TrialComponent } from './trial/trial.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { FooterComponent } from './footer/footer.component';
import { LazyLoadDirective } from './directives/lazy-load/lazy-load.directive';
import { NordicComponent } from './nordic/nordic.component';
import { IndustriesComponent } from './industries/industries.component';
import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../ui/button/button.component';
import { RouterLink } from '@angular/router';



@Component({
    selector: 'app-website',
  imports: [
    MainNavComponent,
    HeroComponent,
    KeyFeaturesComponent,
    CustomersComponent,
    BenefitsComponent,
    TrialComponent,
    ReviewsComponent,
    FooterComponent,
    LazyLoadDirective,
    NordicComponent,
    IndustriesComponent,
    NgOptimizedImage,
    TranslatePipe,
    ButtonComponent,
    RouterLink
  ],
    templateUrl: './website.component.html',
    styleUrls: [
      './website-grid.scss',
      './website-animations.scss',
      './website.component.scss'
    ]
})
export class WebsiteComponent {
  platformId = inject(PLATFORM_ID);
  protected isBrowser = isPlatformBrowser(this.platformId);

  constructor() {
  }

  intersections = {
    hero: true,
    keyFeatures: true,
    industries: true,
    customers: false,
    benefits: false,
    nordic: false,
    cp_preview: false,
    trial: false,
    reviews: false,
    footer: false,
    ai: false
  };

  isIntersecting(status: boolean, index: string): void {
    this.intersections[index] = status;
  }
}
